import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, BuscaPaginada } from './types';

export const INITIAL_STATE: BuscaPaginada = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): BuscaPaginada {
	return produce(state, draft => {
		switch (action.type) {
			case Types.BUSCA_PAGINADA_FORNECEDORES_REQUEST: {
				break;
			}
			case Types.BUSCA_PAGINADA_FORNECEDORES_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.BUSCA_PAGINADA_FORNECEDORES_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.BUSCA_PAGINADA_FORNECEDORES_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
